var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.825 21.024l9.598-19.196 1.13.565 10.162 18.63-1.13 1.13H2.39l-.565-1.13z",
    fill: "#C20101"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.988 17.636a1.13 1.13 0 100 2.26 1.13 1.13 0 000-2.26z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.988 7.615c.467 0 .846.379.846.847v7.057a.847.847 0 01-1.693 0V8.462c0-.468.379-.847.847-.847z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.082 2.223c.725-1.416 2.741-1.439 3.498-.04l9.675 17.901c.712 1.317-.241 2.916-1.738 2.916H2.675c-1.478 0-2.432-1.562-1.76-2.877l9.167-17.9zm2.008.766a.282.282 0 00-.5.006l-9.167 17.9c-.096.188.04.411.252.411h18.842c.214 0 .35-.228.248-.416L12.09 2.99z",
    fill: "#C20101"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.b1c0321c3d670d18287587fc2d1f6c9a.svg";
export { ForwardRef as ReactComponent };